import { useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { Button } from "@jugl-web/ui-kit";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

export const ModuleCard = ({
  title,
  description,
  image,
  animation,
  isNew,
  isUpcoming,
  onReadMoreClick,
}: {
  title: string;
  description: string;
  image: string;
  animation: unknown;
  isNew?: boolean;
  isUpcoming?: boolean;
  onReadMoreClick: () => void;
}) => {
  const { t } = useTranslations();
  return (
    <div className="relative flex h-[356px] w-[275px] flex-col gap-3 rounded-xl bg-[#F8F8F8] p-[6px] font-secondary">
      {isUpcoming && (
        <div className="absolute top-3 right-3 z-10 h-[26px] rounded-[30px] bg-[#FFE2A8] px-4 drop-shadow-[0_4px_4px_rgba(0,0,0,0.10)]">
          <span className="text-xs font-medium text-[#503600]">
            {t({
              id: "workspace-features-showcase.upcoming",
              defaultMessage: "Upcoming",
            })}
          </span>
        </div>
      )}
      {isNew && (
        <div className="absolute top-3 right-3 z-10 h-[26px] rounded-[30px] bg-secondary-200 px-4 drop-shadow-[0_4px_4px_rgba(0,0,0,0.10)]">
          <span className="text-xs font-medium text-secondary-900">
            {t({
              id: "workspace-features-showcase.new",
              defaultMessage: "New",
            })}
          </span>
        </div>
      )}
      <div className="relative flex h-[157px] w-[252px]">
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: animation,
          }}
          height={157}
          width={280}
          style={{
            zIndex: 1,
          }}
        />
        <img
          src={image}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
          alt="decoration"
        />
      </div>
      <div className="relative flex h-[177px] flex-col justify-between rounded-md bg-white p-5">
        <div>
          <div className="text-xl font-medium tracking-[0px] whitespace-nowrap text-black">
            {title}
          </div>
          <div className="pt-2 text-xs leading-[135%] tracking-[-0.1px] text-[#828282]">
            {description}
          </div>
        </div>
        <Button
          className="flex h-[35px] cursor-pointer items-center gap-2 self-end justify-self-end rounded-[20px] text-sm font-normal text-primary-800 transition-all duration-500 hover:gap-4"
          onClick={onReadMoreClick}
          variant="secondary"
          fullWidth
        >
          {t({
            id: "common.learn-more",
            defaultMessage: "Learn more",
          })}
          <ArrowRightIcon />
        </Button>
      </div>
    </div>
  );
};
